import { render } from "./OrgSelect.vue?vue&type=template&id=20e46ebc&scoped=true&ts=true"
import script from "./OrgSelect.vue?vue&type=script&lang=ts"
export * from "./OrgSelect.vue?vue&type=script&lang=ts"

import "./OrgSelect.vue?vue&type=style&index=0&id=20e46ebc&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e46ebc"]])

export default __exports__